import { arrayUnion, doc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

export {
  JULY_FOURTH_COLORS,
  isEmployeeCelebrationUser,
  julyFourthEventId,
  isJulyFourthSeason,
  isJulyFourthPreviewMode,
  clearJulyFourthPreviewMode,
  isJulyFourthLocalDevReplay,
  shouldSkipCelebrationPersistence,
  getJulyFourthBlockReason,
  shouldShowJulyFourthCelebration,
} from './seasonalCelebrationLogic';
export type { JulyFourthBlockReason } from './seasonalCelebrationLogic';

export async function markCelebrationSeen(userId: string, eventId: string): Promise<void> {
  await updateDoc(doc(db, 'users', userId), {
    seenCelebrationIds: arrayUnion(eventId),
  });
}
